export default [
  {
    path: '/dashboard/sifnf',
    name: 'dashboard-sifnf',
    component: () => import('@/views/dashboard/sifnf/SifnfDashboard.vue'),
    meta: {
      pageTitle: 'Своя Игра',
      breadcrumb: [{ text: 'Дэшборд', active: true }],
      resource: 'dashboard',
      action: 'view',
    },
  },
  {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Analytics.vue'),
  },
  {
    path: '/dashboard/ecommerce',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
  },
]
